import { Children, cloneElement, isValidElement } from 'react';
import { isDefined, withKey } from './index.js';
function hasDataProperty(type) {
    if (!type.propTypes) {
        return false;
    }
    return Object.prototype.hasOwnProperty.call(type.propTypes, 'data');
}
function formatProperties(options) {
    const { component, data, inherited } = options;
    if (typeof component === 'string' || !isDefined(data)) {
        return inherited;
    }
    if (hasDataProperty(component) || Array.isArray(data)) {
        return { ...inherited, data };
    }
    return { ...inherited, ...data };
}
function propagateData(children, data, inherited = {}, generateKey = false) {
    return Children.toArray(children)
        .filter(isValidElement)
        .map(child => {
        const properties = formatProperties({
            component: child.type,
            data,
            inherited,
        });
        const props = generateKey ? withKey(properties) : properties;
        return cloneElement(child, props);
    });
}
export { propagateData, };
export default propagateData;
//# sourceMappingURL=propagate-data.js.map